module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleD-img4.22499b03.png";